export default [
  {
    name: '举报页',
    path: '/kids/feedback/harm',
    component: () => import('@/views/kids/feedback/TheHarm.vue'),
  },
  {
    name: '注销账号',
    path: '/kids/apply-for-cancel-account',
    component: () => import('@/views/kids/apply-for-cancel-account/TheIndex.vue'),
  },
  {
    name: '帮助与反馈详情页',
    path: '/kids/help-center/content',
    component: () => import('@/views/kids/help-center/QuestionContent.vue'),
  },
  {
    name: '帮助与反馈',
    path: '/kids/help-center',
    component: () => import('@/views/kids/help-center/QuestionList.vue'),
  },
  {
    name: '微信绑定',
    path: '/kids/wechat-official/bind',
    component: () => import('@/views/kids/wechat-official/WechatOfficialBind.vue'),
  },
];
